import { useContext } from 'react'

// context
import { AppContext } from '../../../../App'

// components

// icons
import { ReactComponent as GreaterThanIcon } from '../../../../assets/icons/greater-than.svg'

// styles
import AssessHealthGraph from './assess-health-graph'
import ClaimAssistPredictionsTag from './claim-assist-predictions-tag'
import styles from './claim-assist-predictions.module.scss'

const ClaimAssistPredictions = (): JSX.Element => {
	const appContext = useContext(AppContext)
	const predictions = appContext?.biomechanicalReport?.claimAssistPredictions

	const toCurrency = (num: number | undefined): string => {
		return `$ ${!num ? 0 : num.toLocaleString('en-CA')}`
	}

	return (
		<>
			<h2>Claim Assist Predictions</h2>
			<div className={styles.container}>
				<div className={styles.predictions}>
					<h3>Expected Outcome Range</h3>
					<p>
						{toCurrency(predictions?.incurredPredictionMin)}
						<GreaterThanIcon />
						<strong>
							{toCurrency(predictions?.incurredPredictionAvg)}
						</strong>
						<GreaterThanIcon />
						{toCurrency(predictions?.incurredPredictionMax)}
					</p>
				</div>

				<div className={styles.risk}>
					<ClaimAssistPredictionsTag
						title="Risk Rank"
						tagLabel={predictions?.riskRank}
					/>
					<ClaimAssistPredictionsTag
						title="Legal Engagement"
						tagLabel={predictions?.legalEngagement}
					/>
					<ClaimAssistPredictionsTag
						title="Claim Volatility"
						tagLabel={predictions?.claimVolatility}
					/>
				</div>

				<div className={styles.graph}>
					{/* <h3>AssessHealth Score</h3> */}
					<AssessHealthGraph score={predictions?.assessHealthScore} />
				</div>

				<div className={styles.notes}>
					<h3>Expedited Claim Assist Prediction</h3>
					<div
						dangerouslySetInnerHTML={{
							__html: predictions?.assessHealthHtmlNote || '',
						}}
					></div>
				</div>

				<p className={styles.message}>
					You can obtain additional AssessHealth<sup>TM</sup> insight
					about potential pre-existing conditions and medical
					utilization that may impact the handling of this claim by
					submitting a valid signed medical authorization.
				</p>
			</div>
		</>
	)
}

export default ClaimAssistPredictions
